import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import ItemModify from '../../Form/ItemModify';

@inject('serverStore')
@observer
class ServerModify extends Component {
  render() {
    const { serverStore, params } = this.props;

    return (
      <ItemModify
        title='Server'
        slug='/configurations/server'
        store={serverStore}
        itemFields={[
          { label: 'Id', key: 'id', type: 'text', readOnly: true, editOnly: true },
          { label: 'URL', key: 'url', type: 'text' },
          { label: 'Caption', key: 'caption', type: 'text' },
          { label: 'Username', key: 'username', type: 'text' },
          { label: 'Password', key: 'password', type: 'password' },
          { label: 'Last Sync', key: 'last_sync', type: 'text', defaultValue: null, readOnly: true, editOnly: true },
        ]}
        params={params}
      />
    );
  }
}

export default ServerModify;



// WEBPACK FOOTER //
// ./src/components/SystemConfiguration/Server/ServerModify.js